import { DataHandlerFolderAdmin, DataHandlerMediaAdmin, FileSystem } from "luxedo-data"

export const FileSystemMedia = new FileSystem({
	file: DataHandlerMediaAdmin,
	folder: DataHandlerFolderAdmin,
})
